import { cn } from "@/lib/cn";

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Convenience for round avatars. */
  circle?: boolean;
}

/**
 * Shimmering placeholder on glass. A translucent base with a diagonal
 * highlight sweeping across via the `shimmer` keyframe.
 */
export function Skeleton({ circle, className, style, ...props }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "animate-shimmer bg-white/6",
        circle ? "rounded-full" : "rounded-lg",
        className,
      )}
      style={{
        backgroundImage:
          "linear-gradient(100deg, transparent 20%, rgba(255,255,255,0.08) 40%, rgba(255,255,255,0.12) 50%, rgba(255,255,255,0.08) 60%, transparent 80%)",
        backgroundSize: "200% 100%",
        ...style,
      }}
      {...props}
    />
  );
}
